/**
 * 签约渠道
 * 2018-3-9
 * geyuankai
 */
"use strict";
angular.module("contractChannelModule", ["contractChannelServiceModule"]).
controller("contractChannelCtrl", ["$scope", "$q", "$element", "$state", "$validation", "httpService", "modalDialog", "contractChannelService", function($scope, $q, $element, $state, $validation, httpService, modalDialog, contractChannelService) {
	initStatus();
	initData();

	function initStatus() {
		$scope.status = {
			UnSelectChannels: true, //用户还有没有可签约的渠道
			disabledTip: '',
		};
		$scope.data = {
			channelStatus: ["weishenhe", "tongguo", "weitongguo"],
			statusText: ["未审核", "已通过", "未通过"],
			channelLogos: [],
		};
	}

	function initData() {
		getChannelList();
		findUnSelectChannels();
		getUserInfo();
	}
	/**
	 * [getChannelList description] 初始化渠道列表
	 * @return {[type]} [description]
	 */
	function getChannelList() {
		$scope.loadingPromise = httpService.http("/mcnww/web/ucenter/pgcUserChannels.do", "", "post").then(function(result) {
			$scope.data.channelLogos = result.data.map(function(o) {
				return o.accountLogo
			});
			/*
			 * 测试数据 end
			 */
			$scope.data.channels = result.data;
		});
	}
	/**
	 * [addContractChannel description] 添加渠道或者编辑渠道的弹窗
	 * @return {[type]} [description]
	 */
	$scope.addOrModifyChannel = function(type, item) {
		contractChannelService.addContractChannel(type, item).then(function(data) {
			$state.go($state.current.name, "", {
				reload: $state.current.name
			}); //刷新页面
		});
	}
	/**
	 * [findUnSelectChannels description] 用户未签约的正常渠道信息 
	 * @return {[type]} [description]
	 */
	function findUnSelectChannels() {
		httpService.http("/mcnww/web/ucenter/findUnSelectChannels.do", "", "post").then(function(result) {
			if(result.data.length == 0) {
				$scope.status.UnSelectChannels = false;
				$scope.status.disabledTip = "您已签约了所有渠道";
			}
		})
	}

	function getUserInfo() {
		$scope.loadingPromise = httpService.http("/mcnww/web/user/getLoginUser.do", "", "get").then(function(data) {
			$scope.status.auditStatus = data.auditStatus;
			if($scope.status.auditStatus == 0 || $scope.status.auditStatus == 2) {
				$scope.status.UnSelectChannels = false;
				$scope.status.disabledTip = "您的帐号还未审核通过";
			}
		});
	};
}]);